export default __webpack_public_path__ + "static/media/empty.cb0ec320.geojson";